export const ShoppingActionTypes = {
    FETCH_REVIEW_REQUEST: "@@Shopping/FETCH_REVIEW_REQUEST",
    FETCH_REVIEW_SUCCESS: "@@Shopping/FETCH_REVIEW_SUCCESS",
    FETCH_REVIEW_FAILURE: "@@Shopping/FETCH_REVIEW_FAILURE",

    CREATE_REVIEW_REQUEST: "@@Shopping/CREATE_REVIEW_REQUEST",
    CREATE_REVIEW_SUCCESS: "@@Shopping/CREATE_REVIEW_SUCCESS",
    CREATE_REVIEW_FAILURE: "@@Shopping/CREATE_REVIEW_FAILURE",

    UPDATE_REVIEW_REQUEST: "@@Shopping/UPDATE_REVIEW_REQUEST",
    UPDATE_REVIEW_SUCCESS: "@@Shopping/UPDATE_REVIEW_SUCCESS",
    UPDATE_REVIEW_FAILURE: "@@Shopping/UPDATE_REVIEW_FAILURE",

    DELETE_REVIEW_REQUEST: "@@Shopping/DELETE_REVIEW_REQUEST",
    DELETE_REVIEW_SUCCESS: "@@Shopping/DELETE_REVIEW_SUCCESS",
    DELETE_REVIEW_FAILURE: "@@Shopping/DELETE_REVIEW_FAILURE",

    FETCH_BANK_ACCOUNT_REQUEST: "@@Shopping/FETCH_BANK_ACCOUNT_REQUEST",
    FETCH_BANK_ACCOUNT_SUCCESS: "@@Shopping/FETCH_BANK_ACCOUNT_SUCCESS",
    FETCH_BANK_ACCOUNT_FAILURE: "@@Shopping/FETCH_BANK_ACCOUNT_FAILURE",

    CREATE_BANK_ACCOUNT_REQUEST: "@@Shopping/CREATE_BANK_ACCOUNT_REQUEST",
    CREATE_BANK_ACCOUNT_SUCCESS: "@@Shopping/CREATE_BANK_ACCOUNT_SUCCESS",
    CREATE_BANK_ACCOUNT_FAILURE: "@@Shopping/CREATE_BANK_ACCOUNT_FAILURE",

    UPDATE_BANK_ACCOUNT_REQUEST: "@@Shopping/UPDATE_BANK_ACCOUNT_REQUEST",
    UPDATE_BANK_ACCOUNT_SUCCESS: "@@Shopping/UPDATE_BANK_ACCOUNT_SUCCESS",
    UPDATE_BANK_ACCOUNT_FAILURE: "@@Shopping/UPDATE_BANK_ACCOUNT_FAILURE",

    DELETE_BANK_ACCOUNT_REQUEST: "@@Shopping/DELETE_BANK_ACCOUNT_REQUEST",
    DELETE_BANK_ACCOUNT_SUCCESS: "@@Shopping/DELETE_BANK_ACCOUNT_SUCCESS",
    DELETE_BANK_ACCOUNT_FAILURE: "@@Shopping/DELETE_BANK_ACCOUNT_FAILURE",

    FETCH_CATEGORY_REQUEST: "@@Shopping/FETCH_CATEGORY_REQUEST",
    FETCH_CATEGORY_SUCCESS: "@@Shopping/FETCH_CATEGORY_SUCCESS",
    FETCH_CATEGORY_FAILURE: "@@Shopping/FETCH_CATEGORY_FAILURE",

    FETCH_CATEGORY_ID_REQUEST: "@@Shopping/FETCH_CATEGORY_ID_REQUEST",
    FETCH_CATEGORY_ID_SUCCESS: "@@Shopping/FETCH_CATEGORY_ID_SUCCESS",
    FETCH_CATEGORY_ID_FAILURE: "@@Shopping/FETCH_CATEGORY_ID_FAILURE",

    CREATE_CATEGORY_REQUEST: "@@Shopping/CREATE_CATEGORY_REQUEST",
    CREATE_CATEGORY_SUCCESS: "@@Shopping/CREATE_CATEGORY_SUCCESS",
    CREATE_CATEGORY_FAILURE: "@@Shopping/CREATE_CATEGORY_FAILURE",

    UPDATE_CATEGORY_REQUEST: "@@Shopping/UPDATE_CATEGORY_REQUEST",
    UPDATE_CATEGORY_SUCCESS: "@@Shopping/UPDATE_CATEGORY_SUCCESS",
    UPDATE_CATEGORY_FAILURE: "@@Shopping/UPDATE_CATEGORY_FAILURE",

    DELETE_CATEGORY_REQUEST: "@@Shopping/DELETE_CATEGORY_REQUEST",
    DELETE_CATEGORY_SUCCESS: "@@Shopping/DELETE_CATEGORY_SUCCESS",
    DELETE_CATEGORY_FAILURE: "@@Shopping/DELETE_CATEGORY_FAILURE",

    FETCH_TRANSACTION_REQUEST: "@@Shopping/FETCH_TRANSACTION_REQUEST",
    FETCH_TRANSACTION_SUCCESS: "@@Shopping/FETCH_TRANSACTION_SUCCESS",
    FETCH_TRANSACTION_FAILURE: "@@Shopping/DELETE_CATEGORY_FAILURE",

    FETCH_PRODUCT_REQUEST: "@@Shopping/FETCH_PRODUCT_REQUEST",
    FETCH_PRODUCT_SUCCESS: "@@Shopping/FETCH_PRODUCT_SUCCESS",
    FETCH_PRODUCT_FAILURE: "@@Shopping/FETCH_PRODUCT_FAILURE",

    FETCH_PRODUCTS_REQUEST: "@@Shopping/FETCH_PRODUCTS_REQUEST",
    FETCH_PRODUCTS_SUCCESS: "@@Shopping/FETCH_PRODUCTS_SUCCESS",
    FETCH_PRODUCTS_FAILURE: "@@Shopping/FETCH_PRODUCTS_FAILURE",

    FETCH_PRODUCT_IDS_REQUEST: "@@Shopping/FETCH_PRODUCT_IDS_REQUEST",
    FETCH_PRODUCT_IDS_SUCCESS: "@@Shopping/FETCH_PRODUCT_IDS_SUCCESS",
    FETCH_PRODUCT_IDS_FAILURE: "@@Shopping/FETCH_PRODUCT_IDS_FAILURE",

    FETCH_PRODUCT_ID_REQUEST: "@@Shopping/FETCH_PRODUCT_ID_REQUEST",
    FETCH_PRODUCT_ID_SUCCESS: "@@Shopping/FETCH_PRODUCT_ID_SUCCESS",
    FETCH_PRODUCT_ID_FAILURE: "@@Shopping/FETCH_PRODUCT_ID_FAILURE",

    CREATE_PRODUCT_REQUEST: "@@Shopping/CREATE_PRODUCT_REQUEST",
    CREATE_PRODUCT_SUCCESS: "@@Shopping/CREATE_PRODUCT_SUCCESS",
    CREATE_PRODUCT_FAILURE: "@@Shopping/CREATE_PRODUCT_FAILURE",

    UPDATE_PRODUCT_REQUEST: "@@Shopping/UPDATE_PRODUCT_REQUEST",
    UPDATE_PRODUCT_SUCCESS: "@@Shopping/UPDATE_PRODUCT_SUCCESS",
    UPDATE_PRODUCT_FAILURE: "@@Shopping/UPDATE_PRODUCT_FAILURE",

    DELETE_PRODUCT_REQUEST: "@@Shopping/DELETE_PRODUCT_REQUEST",
    DELETE_PRODUCT_SUCCESS: "@@Shopping/DELETE_PRODUCT_SUCCESS",
    DELETE_PRODUCT_FAILURE: "@@Shopping/DELETE_PRODUCT_FAILURE",

    UPDATE_PRODUCT_STATUS_REQUEST: "@@Shopping/UPDATE_PRODUCT_STATUS_REQUEST",
    UPDATE_PRODUCT_STATUS_SUCCESS: "@@Shopping/UPDATE_PRODUCT_STATUS_SUCCESS",
    UPDATE_PRODUCT_STATUS_FAILURE: "@@Shopping/UPDATE_PRODUCT_STATUS_FAILURE",

    FETCH_PAYMENT_CONFIG_REQUEST: "@@Shopping/FETCH_PAYMENT_CONFIG_REQUEST",
    FETCH_PAYMENT_CONFIG_SUCCESS: "@@Shopping/FETCH_PAYMENT_CONFIG_SUCCESS",
    FETCH_PAYMENT_CONFIG_FAILURE: "@@Shopping/FETCH_PAYMENT_CONFIG_FAILURE",

    FETCH_PAYMENT_PAYOUT_REQUEST: "@@Shopping/FETCH_PAYMENT_PAYOUT_REQUEST",
    FETCH_PAYMENT_PAYOUT_SUCCESS: "@@Shopping/FETCH_PAYMENT_PAYOUT_SUCCESS",
    FETCH_PAYMENT_PAYOUT_FAILURE: "@@Shopping/FETCH_PAYMENT_PAYOUT_FAILURE",

    CREATE_SUBSCRIPTION_REQUEST: "@@Shopping/CREATE_SUBSCRIPTION_REQUEST",
    CREATE_SUBSCRIPTION_SUCCESS: "@@Shopping/CREATE_SUBSCRIPTION_SUCCESS",
    CREATE_SUBSCRIPTION_FAILURE: "@@Shopping/CREATE_SUBSCRIPTION_FAILURE",

    UPGRADE_ACCOUNT_REQUEST: "@@Shopping/UPGRADE_ACCOUNT_REQUEST",
    UPGRADE_ACCOUNT_SUCCESS: "@@Shopping/UPGRADE_ACCOUNT_SUCCESS",
    UPGRADE_ACCOUNT_FAILURE: "@@Shopping/UPGRADE_ACCOUNT_FAILURE",

    FETCH_PLANS_REQUEST: "@@Shopping/FETCH_PLANS_REQUEST",
    FETCH_PLANS_SUCCESS: "@@Shopping/FETCH_PLANS_SUCCESS",
    FETCH_PLANS_FAILURE: "@@Shopping/FETCH_PLANS_FAILURE",

    CREATE_ORDERGROUP_REQUEST: "@@Shopping/CREATE_ORDERGROUP_REQUEST",
    CREATE_ORDERGROUP_SUCCESS: "@@Shopping/CREATE_ORDERGROUP_SUCCESS",
    CREATE_ORDERGROUP_FAILURE: "@@Shopping/CREATE_ORDERGROUP_FAILURE",

    FETCH_ORDER_REQUEST: "@@Shopping/FETCH_ORDER_REQUEST",
    FETCH_ORDER_SUCCESS: "@@Shopping/FETCH_ORDER_SUCCESS",
    FETCH_ORDER_FAILURE: "@@Shopping/FETCH_ORDER_FAILURE",

    FETCH_ORDER_ID_REQUEST: "@@Shopping/FETCH_ORDER_ID_REQUEST",
    FETCH_ORDER_ID_SUCCESS: "@@Shopping/FETCH_ORDER_ID_SUCCESS",
    FETCH_ORDER_ID_FAILURE: "@@Shopping/FETCH_ORDER_ID_FAILURE",

    CREATE_ORDER_REQUEST: "@@Shopping/CREATE_ORDER_REQUEST",
    CREATE_ORDER_SUCCESS: "@@Shopping/CREATE_ORDER_SUCCESS",
    CREATE_ORDER_FAILURE: "@@Shopping/CREATE_ORDER_FAILURE",

    UPDATE_ORDER_REQUEST: "@@Shopping/UPDATE_ORDER_REQUEST",
    UPDATE_ORDER_SUCCESS: "@@Shopping/UPDATE_ORDER_SUCCESS",
    UPDATE_ORDER_FAILURE: "@@Shopping/UPDATE_ORDER_FAILURE",

    CREATE_PRODUCT_SUBSCRIPTION_REQUEST:
        "@@Shopping/CREATE_PRODUCT_SUBSCRIPTION_REQUEST",
    CREATE_PRODUCT_SUBSCRIPTION_SUCCESS:
        "@@Shopping/CREATE_PRODUCT_SUBSCRIPTION_SUCCESS",
    CREATE_PRODUCT_SUBSCRIPTION_FAILURE:
        "@@Shopping/CREATE_PRODUCT_SUBSCRIPTION_FAILURE",

    CANCEL_PRODUCT_SUBSCRIPTION_REQUEST:
        "@@Shopping/CANCEL_PRODUCT_SUBSCRIPTION_REQUEST",
    CANCEL_PRODUCT_SUBSCRIPTION_SUCCESS:
        "@@Shopping/CANCEL_PRODUCT_SUBSCRIPTION_SUCCESS",
    CANCEL_PRODUCT_SUBSCRIPTION_FAILURE:
        "@@Shopping/CANCEL_PRODUCT_SUBSCRIPTION_FAILURE",

    CREATE_SUBSCRIPTION_PRICE_REQUEST:
        "@@Shopping/CREATE_SUBSCRIPTION_PRICE_REQUEST",
    CREATE_SUBSCRIPTION_PRICE_SUCCESS:
        "@@Shopping/CREATE_SUBSCRIPTION_PRICE_SUCCESS",
    CREATE_SUBSCRIPTION_PRICE_FAILURE:
        "@@Shopping/CREATE_SUBSCRIPTION_PRICE_FAILURE",

    UPDATE_SUBSCRIPTION_PRICE_REQUEST:
        "@@Shopping/UPDATE_SUBSCRIPTION_PRICE_REQUEST",
    UPDATE_SUBSCRIPTION_PRICE_SUCCESS:
        "@@Shopping/UPDATE_SUBSCRIPTION_PRICE_SUCCESS",
    UPDATE_SUBSCRIPTION_PRICE_FAILURE:
        "@@Shopping/UPDATE_SUBSCRIPTION_PRICE_FAILURE",

    CANCEL_SUBSCRIPTION_TIME_REQUEST:
        "@@Shopping/CANCEL_SUBSCRIPTION_TIME_REQUEST",
    CANCEL_SUBSCRIPTION_TIME_SUCCESS:
        "@@Shopping/CANCEL_SUBSCRIPTION_TIME_SUCCESS",
    CANCEL_SUBSCRIPTION_TIME_FAILURE:
        "@@Shopping/CANCEL_SUBSCRIPTION_TIME_FAILURE",

    ADD_TRIAL_SUBSCRIPTION_REQUEST: "@@Shopping/ADD_TRIAL_SUBSCRIPTION_REQUEST",
    ADD_TRIAL_SUBSCRIPTION_SUCCESS: "@@Shopping/ADD_TRIAL_SUBSCRIPTION_SUCCESS",
    ADD_TRIAL_SUBSCRIPTION_FAILURE: "@@Shopping/ADD_TRIAL_SUBSCRIPTION_FAILURE",

    ADD_BASIC_SUBSCRIPTION_REQUEST: "@@Shopping/ADD_BASIC_SUBSCRIPTION_REQUEST",
    ADD_BASIC_SUBSCRIPTION_SUCCESS: "@@Shopping/ADD_BASIC_SUBSCRIPTION_SUCCESS",
    ADD_BASIC_SUBSCRIPTION_FAILURE: "@@Shopping/ADD_BASIC_SUBSCRIPTION_FAILURE",

    ADD_TRIALBASIC_SUBSCRIPTION_REQUEST:
        "@@Shopping/ADD_TRIALBASIC_SUBSCRIPTION_REQUEST",
    ADD_TRIALBASIC_SUBSCRIPTION_SUCCESS:
        "@@Shopping/ADD_TRIALBASIC_SUBSCRIPTION_SUCCESS",
    ADD_TRIALBASIC_SUBSCRIPTION_FAILURE:
        "@@Shopping/ADD_TRIALBASIC_SUBSCRIPTION_FAILURE",

    CREATE_CART_REQUEST: "@@Shopping/CREATE_CART_REQUEST",
    CREATE_CART_SUCCESS: "@@Shopping/CREATE_CART_SUCCESS",
    CREATE_CART_FAILURE: "@@Shopping/CREATE_CART_FAILURE",

    UPDATE_CART_REQUEST: "@@Shopping/UPDATE_CART_REQUEST",
    UPDATE_CART_SUCCESS: "@@Shopping/UPDATE_CART_SUCCESS",
    UPDATE_CART_FAILURE: "@@Shopping/UPDATE_CART_FAILURE",

    FETCH_CART_REQUEST: "@@Shopping/FETCH_CART_REQUEST",
    FETCH_CART_SUCCESS: "@@Shopping/FETCH_CART_SUCCESS",
    FETCH_CART_FAILURE: "@@Shopping/FETCH_CART_FAILURE",

    CLEAR_SHOPPING_REQUEST: "@@Shopping/CLEAR_SHOPPING_REQUEST",
    SELECT_EXISTING_PRODUCT: "@@Shopping/SELECT_EXISTING_PRODUCT",
    DELETE_EXISTING_PRODUCT: "@@Shopping/DELETE_EXISTING_PRODUCT",
    DELETE_EXISTING_ALL_PRODUCT: "@@Shopping/DELETE_EXISTING_ALL_PRODUCT",

    SET_INSTANT_VIDEO: "@@Shopping/SET_INSTANT_VIDEO",
};
